
  
  var splide = new Splide( '#box8-splide', {
    type   : 'loop',
    focus: 'center',
    height: 900, 
    lazyLoad: 'nearby',
    autoWidth: true,
    breakpoints: {
      2560: {
        height: 900, 
        autoWidth: true,
      },
      1920: {
        height:620,
      },
      750: {
        height:400,
        autoWidth: false,
        autoHeight: true,
      },
    },
  } );
  
  splide.mount();



gsap.registerPlugin(ScrollTrigger);

const video3Text = document.querySelector('.box3-video_text') ;
const video3CanvasImg = document.querySelector('.box3-video_img-canvas') ;
const canvas = document.getElementById("box3-video_canvas");
const context = canvas.getContext("2d");


let box2UpVideo1 = document.getElementById("box2-up-video1");
let box2UpVideo2 = document.getElementById("box2-up-video2");
// let box2SplideVideoPlay2 = videojs('box2-splide-video2');
const proNameL = document.querySelectorAll(".content-l-name .name-item");
const proNameR = document.querySelectorAll(".content-r-name .name-item");

const box3UpVideo = document.getElementById("box3-up-video");
const box3UpImg = document.querySelector('.box-up3-top_img');
const box3UpText = document.querySelector('.box-up3-top_text');
const box2UpVideoImg = document.querySelectorAll('.box2-up-video img');

let videoOpen = false
let videoOpenNum = 0
proNameL[0].addEventListener('click', ()=>{
  if(!videoOpen &&videoOpenNum == 1){
    videoOpen = true
    videoOpenNum = 0
    
    box2UpVideo1.play()
    box2UpVideo2.classList.remove('active')
    box2UpVideo1.classList.add('active')
    setTimeout(()=>{
      box2UpVideoImg[1].style.display = 'none'
    }, 100);
    proNameL.forEach((item) => item.classList.remove('active'));
    proNameL[0].classList.add('active');
  }
})
proNameL[1].addEventListener('click', ()=>{
  if(!videoOpen&&videoOpenNum == 0){
    videoOpen = true
    videoOpenNum = 1
    
    box2UpVideo2.play()
    box2UpVideo1.classList.remove('active')
    box2UpVideo2.classList.add('active')
    setTimeout(()=>{
      box2UpVideoImg[0].style.display = 'none'
    }, 100);
    
    proNameL.forEach((item) => item.classList.remove('active'));
    proNameL[1].classList.add('active');
  }
})

proNameR[0].addEventListener('click', ()=>{
  if(!videoOpen &&videoOpenNum == 1){
    videoOpen = true
    videoOpenNum = 0
    box2UpVideo2.currentTime = 0;
    box2UpVideo1.play()
    box2UpVideo2.classList.remove('active')
    box2UpVideo1.classList.add('active')
    setTimeout(()=>{
      box2UpVideoImg[1].style.display = 'none'
    }, 100);
    proNameR.forEach((item) => item.classList.remove('active'));
    proNameR[0].classList.add('active');
  }
})
proNameR[1].addEventListener('click', ()=>{
  if(!videoOpen&&videoOpenNum == 0){
    videoOpen = true
    videoOpenNum = 1
    box2UpVideo1.currentTime = 0;
    box2UpVideo2.play()
    box2UpVideo1.classList.remove('active')
    box2UpVideo2.classList.add('active')
    setTimeout(()=>{
      box2UpVideoImg[0].style.display = 'none'
    }, 100);
    proNameR.forEach((item) => item.classList.remove('active'));
    proNameR[1].classList.add('active');
  }
})

box2UpVideo1.addEventListener("ended", checkVideoEnded1);
box2UpVideo2.addEventListener("ended", checkVideoEnded2);
function checkVideoEnded1() {
  if (box2UpVideo1.ended || box2UpVideo2.ended) {
    videoOpen = false
  } 
  if(box2UpVideo1.ended){
    box2UpVideoImg[0].style.display = 'block'
    box2UpVideoImg[1].style.display = 'none'
  }
}
function checkVideoEnded2() {
  if (box2UpVideo1.ended || box2UpVideo2.ended) {
    videoOpen = false
  } 
  if(box2UpVideo2.ended){
    box2UpVideoImg[1].style.display = 'block'
    box2UpVideoImg[0].style.display = 'none'
  }
}






const box4CItem = document.querySelectorAll(".box4-c-l_img");
const box4CSvg = document.querySelectorAll(".box4-c-r_svg .svg-r_item");
const box4CText = document.querySelectorAll(".content-r_item");


const featureTitle = document.querySelectorAll(".feature-item-title");
const featureList = document.querySelectorAll(".feature-item-list");

const box6VideoImg = document.querySelectorAll(".box6-video-img");
const box6VideoImgNext = document.querySelectorAll(".box6-video-img img");
const videoButMp4 = document.querySelectorAll(".video-but-mp4");



const box9TabImg = document.querySelectorAll(".right_bottom-img-list .img-list_item");
const box9TabSvg = document.querySelectorAll(".right_bottom-tab-list li");

const line1 = document.querySelector('.line-text_item1') ;
const line2 = document.querySelector('.line-text_item2') ;
// const line3 = document.querySelector('.line-text_item3') ;
const line4 = document.querySelector('.line-text_item4') ;
const line5 = document.querySelector('.line-text_item5') ;

let w = window.innerWidth
let box3UpVideoUrl = ''
if(w < 1920){
  box3UpVideoUrl = 'https://cdn.shopify.com/videos/c/o/v/457818c4faf6404398e0972dfa860e09.mp4'
}else{
  box3UpVideoUrl = 'https://cdn.shopify.com/videos/c/o/v/e876af07f43147519c9c9abdd851c5c5.mp4'
}

ScrollTrigger.matchMedia({
  "(min-width: 750px)": function() {
    let na3c = 0
    const frameCount = 35;
    const images = []

    canvas.width = 1440;
    canvas.height = 900;
    // https://cdn.shopify.com/s/files/1/0604/6410/3654/files/03_0913_15fps_00026.png?v=1701761668
    
    const currentFrame = index => (
      // `https://cdn.shopify.com/s/files/1/0606/1824/4315/files/03_0913_15fps_${(index).toString().padStart(5, '0')}.png`
      `https://cdn.shopify.com/s/files/1/0604/6410/3654/files/03_0913_15fps_${(index).toString().padStart(5, '0')}.png`
    );
    
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.push(img);
    }

    ScrollTrigger.create({
      trigger: '.box3-video',
      start: 'top top',
      end:'+=90%',
      scrub: true,
      pin:true,
      onUpdate(self){
        
          let imgIndex = Math.ceil(self.progress * frameCount);
          na3c = imgIndex - 1
          
          if (na3c < 0) na3c = 0
    
          if(na3c<=frameCount){
            render()
          }
          
          if(na3c>16) {
            line1.classList.add('active');
            line2.classList.add('active');
            // line3.classList.add('active');
          }else{
            line1.classList.remove('active');
            line2.classList.remove('active');
            // line3.classList.remove('active');
          }
    
          if(na3c>21) {
            line4.classList.add('active');
          }else{
            line4.classList.remove('active');
          }
    
          if(na3c>27) {
            line5.classList.add('active');
          }else{
            line5.classList.remove('active');
          }
          
          
    
          if(self.progress > 0){
            video3CanvasImg.style.display = 'none'
            canvas.style.display = 'block'
          }else{
            video3CanvasImg.style.display = 'block'
            canvas.style.display = 'none'
          }
          
          if(self.progress == 1){
            video3Text.style.opacity = '1'
          }else{
            video3Text.style.opacity = '0'
          }
        }
    })
    
    images[0].onload = render;
    
    function render() {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(images[na3c], 0, 0); 
    }

    ScrollTrigger.create({
      trigger: '.box4-c',
      start: 'top +=60',
      end:'+=1500 center',
      scrub: true,
      pin: true,
      onUpdate(self){
    
        if(self.progress>0.2){
          box4CItem.forEach((item) => item.classList.remove('active'));
          box4CSvg.forEach((item) => item.classList.remove('active'));
          box4CText.forEach((item) => item.classList.remove('active'));
          
          box4CItem[1].classList.add('active');
          box4CSvg[1].classList.add('active');
          box4CText[1].classList.add('active');
        }
    
        if(self.progress>0.5){
          box4CItem.forEach((item) => item.classList.remove('active'));
          box4CSvg.forEach((item) => item.classList.remove('active'));
          box4CText.forEach((item) => item.classList.remove('active'));
          box4CItem[2].classList.add('active');
          box4CSvg[2].classList.add('active');
          box4CText[2].classList.add('active');
        }
    
        if(self.progress>0.7){
          box4CItem.forEach((item) => item.classList.remove('active'));
          box4CSvg.forEach((item) => item.classList.remove('active'));
          box4CText.forEach((item) => item.classList.remove('active'));
          box4CItem[3].classList.add('active');
          box4CSvg[3].classList.add('active');
          box4CText[3].classList.add('active');
        }
    
        if(self.progress<0.2){
          box4CItem.forEach((item) => item.classList.remove('active'));
          box4CSvg.forEach((item) => item.classList.remove('active'));
          box4CText.forEach((item) => item.classList.remove('active'));
          box4CItem[0].classList.add('active');
          box4CSvg[0].classList.add('active');
          box4CText[0].classList.add('active');
        }
      }
    })

    // 获取要测量距离的元素
    var element = document.getElementById("box4");

    // 使用 offsetTop 属性获取元素距离页面顶部的距离
    var distanceToTop = element.offsetTop;

    const box4T = document.querySelector('.box4-c');
    var parentElement = box4T.parentNode;
    var parentElementH = parentElement.offsetHeight

    
    box4CSvg.forEach((item,index)=>{
      item.addEventListener('click',()=>{
        let sy = parseInt(parentElementH/4 - 200)
        sy = parseInt(sy*(index+1)-sy)
        sy = Math.max(sy, 0);
        sy = sy+200
        window.scrollTo(0,distanceToTop+sy)
      })
    })

    ScrollTrigger.create({
      trigger: '.box-up3',
      start: 'top 70%',
      end:'bottom center',
      scrub: true,
      onEnter(){
        if (!box3UpVideo.src) {
          box3UpVideo.src = box3UpVideoUrl
        }
        box3UpVideo.play()
      },
      onUpdate(self){
        let numIndex = self.progress;
        if(numIndex > 0){
          box3UpImg.classList.add('animated-element')
          box3UpText.classList.add('animated-element')
        }else{
          box3UpImg.classList.remove('animated-element')
          box3UpText.classList.remove('animated-element')
        }
      }
    })

  },
  "(max-width: 750px)": function() {
    let na3c = 0
    const frameCount = 35;
    const images = []

    canvas.width = 750;
    canvas.height = 700;
    
    const currentFrame = index => (
      // `https://cdn.shopify.com/s/files/1/0606/1824/4315/files/03__15fps_${(index).toString().padStart(5, '0')}.png`
      `https://cdn.shopify.com/s/files/1/0604/6410/3654/files/03__15fps_${(index).toString().padStart(5, '0')}.png`
    );
    
    for (let i = 0; i < frameCount; i++) {
      const img = new Image();
      img.src = currentFrame(i);
      images.push(img);
    }

    ScrollTrigger.create({
      trigger: '.box3-video',
      start: 'top +=75',
      end:'+=90%',
      scrub: true,
      pin:true,
      onUpdate(self){
        
          let imgIndex = Math.ceil(self.progress * frameCount);
          na3c = imgIndex - 1
          
          if (na3c < 0) na3c = 0
    
          if(na3c<=frameCount){
            render()
          }
          
          if(na3c>16) {
            line1.classList.add('active');
            line2.classList.add('active');
            // line3.classList.add('active');
          }else{
            line1.classList.remove('active');
            line2.classList.remove('active');
            // line3.classList.remove('active');
          }
    
          if(na3c>21) {
            line4.classList.add('active');
          }else{
            line4.classList.remove('active');
          }
    
          if(na3c>27) {
            line5.classList.add('active');
          }else{
            line5.classList.remove('active');
          }
          
          
    
          if(self.progress > 0){
            video3CanvasImg.style.display = 'none'
            canvas.style.display = 'block'
          }else{
            video3CanvasImg.style.display = 'block'
            canvas.style.display = 'none'
          }
          
          if(self.progress == 1){
            video3Text.style.opacity = '1'
          }else{
            video3Text.style.opacity = '0'
          }
        }
    })
    
    images[0].onload = render;
    
    function render() {
      context.clearRect(0, 0, canvas.width, canvas.height);
      context.drawImage(images[na3c], 0, 0); 
    }

    ScrollTrigger.create({
      trigger: '.box4-c',
      start: 'top +=75',
      end:'+=1500 center',
      scrub: true,
      pin: true,
      onUpdate(self){
        if(self.progress>0.2){ 
          box4CItem.forEach((item) => item.classList.remove('active'));
          box4CSvg.forEach((item) => item.classList.remove('active'));
          box4CText.forEach((item) => item.classList.remove('active'));
          
          box4CItem[1].classList.add('active');
          box4CSvg[1].classList.add('active');
          box4CText[1].classList.add('active');
        }
    
        if(self.progress>0.5){
          box4CItem.forEach((item) => item.classList.remove('active'));
          box4CSvg.forEach((item) => item.classList.remove('active'));
          box4CText.forEach((item) => item.classList.remove('active'));
          box4CItem[2].classList.add('active');
          box4CSvg[2].classList.add('active');
          box4CText[2].classList.add('active');
        }
    
        if(self.progress>0.7){
          box4CItem.forEach((item) => item.classList.remove('active'));
          box4CSvg.forEach((item) => item.classList.remove('active'));
          box4CText.forEach((item) => item.classList.remove('active'));
          box4CItem[3].classList.add('active');
          box4CSvg[3].classList.add('active');
          box4CText[3].classList.add('active');
        }
    
        if(self.progress<0.2){
          box4CItem.forEach((item) => item.classList.remove('active'));
          box4CSvg.forEach((item) => item.classList.remove('active'));
          box4CText.forEach((item) => item.classList.remove('active'));
          box4CItem[0].classList.add('active');
          box4CSvg[0].classList.add('active');
          box4CText[0].classList.add('active');
        }
      }
    })

    // 获取要测量距离的元素
    var element = document.getElementById("box4");

    // 使用 offsetTop 属性获取元素距离页面顶部的距离
    var distanceToTop = element.offsetTop;

    const box4T = document.querySelector('.box4-c');
    var parentElement = box4T.parentNode;
    var parentElementH = parentElement.offsetHeight

    
    box4CSvg.forEach((item,index)=>{
      item.addEventListener('click',()=>{
        let sy = parseInt(parentElementH/4 - 200)
        sy = parseInt(sy*(index+1)-sy)
        sy = Math.max(sy, 0);
        sy = sy+200
        window.scrollTo(0,distanceToTop+sy)
      })
    })

    ScrollTrigger.create({
      trigger: '.box-up3',
      start: 'top 80%',
      end:'bottom bottom',
      scrub: true,
      onEnter(){
        if (!box3UpVideo.src) {
          box3UpVideo.src = box3UpVideoUrl
        }
        box3UpVideo.play()
      },
      onUpdate(self){
        let numIndex = self.progress;
        if(numIndex > 0){
          box3UpImg.classList.add('animated-element')
          box3UpText.classList.add('animated-element')
        }else{
          box3UpImg.classList.remove('animated-element')
          box3UpText.classList.remove('animated-element')
        }
      }
    })

  }
})

ScrollTrigger.create({
  trigger: '.box3',
  start: 'top center',
  end:'200 +=200',
  scrub: true,
  animation:
    gsap.timeline()
    .fromTo('.box3',{background:'#F8F8F8'},{background:'#1B1B1B '},'<')
    .fromTo('.box3-info h2',{color:'#262626'},{color:'#F2F2F2'},'<')
})





let marker = document.querySelector("#marker2");
let tabItem = document.querySelectorAll(".box7-tab a");
let tabItemContent = document.querySelectorAll(".box7-tab-c-item");

function indicator(e){
  marker.style.left = e.offsetLeft + 'px';
  marker.style.width = e.offsetWidth + 'px';
}

tabItem.forEach((link,index) => {
  
  link.addEventListener('mouseover', (e)=>{
    indicator(e.target)

    tabItemContent.forEach(item => {
      item.classList.remove("box7-active");
    })
    tabItem.forEach(item => {
      item.classList.remove("box7-tab-active");
    })

    tabItem[index].classList.add("box7-tab-active");
    tabItemContent[index].classList.add("box7-active");
  })

  link.addEventListener('click', (e)=>{
    indicator(e.target)

    tabItemContent.forEach(item => {
      item.classList.remove("box7-active");
    })
    tabItem.forEach(item => {
      item.classList.remove("box7-tab-active");
    })

    tabItem[index].classList.add("box7-tab-active");
    tabItemContent[index].classList.add("box7-active");
  })

})

featureTitle.forEach((item,index)=>{
  item.addEventListener('click', ()=>{
    featureTitle.forEach((item) => item.classList.remove('active'));
    featureList.forEach((item) => item.classList.remove('active'));
    featureList[index].classList.add('active');
    item.classList.add('active');
  })
})

box9TabSvg.forEach((item,index)=>{
  item.addEventListener('click', ()=>{
    box9TabSvg.forEach((item) => item.classList.remove('active'));
    box9TabImg.forEach((item) => item.classList.remove('active'));
    box9TabImg[index].classList.add('active');
    item.classList.add('active');
  })
})

videoButMp4.forEach((item,index) => {
  item.addEventListener('click', ()=>{
    const videoWidth = item.dataset.width;
    const videoHeight = item.dataset.height;
    const videoSrc = item.dataset.src;
  
    let videoCode = `
    <video muted width="${videoWidth}" height="${videoHeight}" controls="controls" autoplay="autoplay" >
    <source src="${videoSrc}" />
    <source src="movie.ogg" type="video/ogg" />
    Your browser does not support the video tag.
    </video>
    `
    item.style.display = 'none'
    box6VideoImgNext[index].style.display = 'none'
    box6VideoImg[index].innerHTML= videoCode
  })
  
})



// 获取 Splide 实例
// var splide = new Splide('#box8-splide', {
//   type: 'loop',
//   drag: 'free',
//   focus: 'center',
//   arrows: false, // 取消箭头
//   pagination: false, // 取消下标
//   perPage: 1.7,
//   autoScroll: false,
//   lazyLoad: 'nearby',
//   height:900,
//   breakpoints: {
//     992: {
//       perPage: 1
//     },
//   },
// }).mount();



